// 한국 행정구역 계층 데이터 (시/도 → 구/시/군)
export const REGION_HIERARCHY: Record<string, string[]> = {
  서울: ['강남구', '강동구', '강북구', '강서구', '관악구', '광진구', '구로구', '금천구', '노원구', '도봉구', '동대문구', '동작구', '마포구', '서대문구', '서초구', '성동구', '성북구', '송파구', '양천구', '영등포구', '용산구', '은평구', '종로구', '중구', '중랑구'],
  경기: ['수원시', '성남시', '고양시', '용인시', '부천시', '안산시', '안양시', '남양주시', '화성시', '평택시', '의정부시', '시흥시', '파주시', '광명시', '김포시', '군포시', '광주시', '이천시', '양주시', '구리시', '오산시', '안성시', '포천시', '의왕시', '하남시', '여주시', '양평군', '가평군', '연천군'],
  인천: ['중구', '동구', '미추홀구', '연수구', '남동구', '부평구', '계양구', '서구', '강화군', '옹진군'],
  부산: ['중구', '서구', '동구', '영도구', '부산진구', '동래구', '남구', '북구', '해운대구', '사하구', '금정구', '강서구', '연제구', '수영구', '사상구', '기장군'],
  대구: ['중구', '동구', '서구', '남구', '북구', '수성구', '달서구', '달성군'],
  광주: ['동구', '서구', '남구', '북구', '광산구'],
  대전: ['동구', '중구', '서구', '유성구', '대덕구'],
  울산: ['중구', '남구', '동구', '북구', '울주군'],
  세종: ['세종시'],
  강원: ['춘천시', '원주시', '강릉시', '동해시', '태백시', '속초시', '삼척시', '홍천군', '횡성군', '영월군', '평창군', '정선군', '철원군', '화천군', '양구군', '인제군', '고성군', '양양군'],
  충북: ['청주시', '충주시', '제천시', '보은군', '옥천군', '영동군', '증평군', '진천군', '괴산군', '음성군', '단양군'],
  충남: ['천안시', '공주시', '보령시', '아산시', '서산시', '논산시', '계룡시', '당진시', '금산군', '부여군', '서천군', '청양군', '홍성군', '예산군', '태안군'],
  전북: ['전주시', '군산시', '익산시', '정읍시', '남원시', '김제시', '완주군', '진안군', '무주군', '장수군', '임실군', '순창군', '고창군', '부안군'],
  전남: ['목포시', '여수시', '순천시', '나주시', '광양시', '담양군', '곡성군', '구례군', '고흥군', '보성군', '화순군', '장흥군', '강진군', '해남군', '영암군', '무안군', '함평군', '영광군', '장성군', '완도군', '진도군', '신안군'],
  경북: ['포항시', '경주시', '김천시', '안동시', '구미시', '영주시', '영천시', '상주시', '문경시', '경산시', '의성군', '청송군', '영양군', '영덕군', '청도군', '고령군', '성주군', '칠곡군', '예천군', '봉화군', '울진군', '울릉군'],
  경남: ['창원시', '진주시', '통영시', '사천시', '김해시', '밀양시', '거제시', '양산시', '의령군', '함안군', '창녕군', '고성군', '남해군', '하동군', '산청군', '함양군', '거창군', '합천군'],
  제주: ['제주시', '서귀포시'],
};

export const ALL_PROVINCES = Object.keys(REGION_HIERARCHY);

// 전국 시/도 및 구/시/군 중심 좌표 (거리 계산용, 구 단위 정밀도)
export const REGION_COORDINATES: Record<string, { lat: number; lng: number }> = {
  // ── 시/도 중심 ──
  서울: { lat: 37.5665, lng: 126.978 },
  경기: { lat: 37.4138, lng: 127.5183 },
  인천: { lat: 37.4563, lng: 126.7052 },
  부산: { lat: 35.1796, lng: 129.0756 },
  대구: { lat: 35.8714, lng: 128.6014 },
  광주: { lat: 35.1595, lng: 126.8526 },
  대전: { lat: 36.3504, lng: 127.3845 },
  울산: { lat: 35.5384, lng: 129.3114 },
  세종: { lat: 36.48, lng: 127.289 },
  강원: { lat: 37.8228, lng: 128.1555 },
  충북: { lat: 36.8, lng: 127.7 },
  충남: { lat: 36.5184, lng: 126.8 },
  전북: { lat: 35.7175, lng: 127.153 },
  전남: { lat: 34.816, lng: 126.4629 },
  경북: { lat: 36.4919, lng: 128.8889 },
  경남: { lat: 35.4606, lng: 128.2132 },
  제주: { lat: 33.489, lng: 126.4983 },

  // ── 서울 ──
  '서울 강남구': { lat: 37.4979, lng: 127.0276 },
  '서울 강동구': { lat: 37.5301, lng: 127.1238 },
  '서울 강북구': { lat: 37.6396, lng: 127.0257 },
  '서울 강서구': { lat: 37.5509, lng: 126.8495 },
  '서울 관악구': { lat: 37.4784, lng: 126.9516 },
  '서울 광진구': { lat: 37.5385, lng: 127.0827 },
  '서울 구로구': { lat: 37.4955, lng: 126.8874 },
  '서울 금천구': { lat: 37.4569, lng: 126.8954 },
  '서울 노원구': { lat: 37.6544, lng: 127.0566 },
  '서울 도봉구': { lat: 37.6688, lng: 127.0471 },
  '서울 동대문구': { lat: 37.5745, lng: 127.0396 },
  '서울 동작구': { lat: 37.5121, lng: 126.9395 },
  '서울 마포구': { lat: 37.5663, lng: 126.9017 },
  '서울 서대문구': { lat: 37.5791, lng: 126.9368 },
  '서울 서초구': { lat: 37.4837, lng: 127.0324 },
  '서울 성동구': { lat: 37.5633, lng: 127.0369 },
  '서울 성북구': { lat: 37.5894, lng: 127.0167 },
  '서울 송파구': { lat: 37.5146, lng: 127.1059 },
  '서울 양천구': { lat: 37.517, lng: 126.8667 },
  '서울 영등포구': { lat: 37.5264, lng: 126.8963 },
  '서울 용산구': { lat: 37.5326, lng: 126.9905 },
  '서울 은평구': { lat: 37.6027, lng: 126.9291 },
  '서울 종로구': { lat: 37.5729, lng: 126.9793 },
  '서울 중구': { lat: 37.564, lng: 126.9978 },
  '서울 중랑구': { lat: 37.6066, lng: 127.0927 },

  // ── 경기 ──
  '경기 수원시': { lat: 37.2636, lng: 127.0286 },
  '경기 성남시': { lat: 37.42, lng: 127.1267 },
  '경기 고양시': { lat: 37.6584, lng: 126.832 },
  '경기 용인시': { lat: 37.2412, lng: 127.1776 },
  '경기 부천시': { lat: 37.5035, lng: 126.766 },
  '경기 안산시': { lat: 37.3219, lng: 126.8309 },
  '경기 안양시': { lat: 37.3943, lng: 126.9568 },
  '경기 남양주시': { lat: 37.6358, lng: 127.2165 },
  '경기 화성시': { lat: 37.1995, lng: 126.831 },
  '경기 평택시': { lat: 36.9923, lng: 127.1127 },
  '경기 의정부시': { lat: 37.7381, lng: 127.0337 },
  '경기 시흥시': { lat: 37.3802, lng: 126.8028 },
  '경기 파주시': { lat: 37.7599, lng: 126.78 },
  '경기 광명시': { lat: 37.4786, lng: 126.8645 },
  '경기 김포시': { lat: 37.6152, lng: 126.7156 },
  '경기 군포시': { lat: 37.3615, lng: 126.9353 },
  '경기 광주시': { lat: 37.4293, lng: 127.2554 },
  '경기 이천시': { lat: 37.2797, lng: 127.4422 },
  '경기 양주시': { lat: 37.7853, lng: 127.046 },
  '경기 구리시': { lat: 37.5943, lng: 127.1294 },
  '경기 오산시': { lat: 37.1499, lng: 127.0706 },
  '경기 안성시': { lat: 37.0079, lng: 127.2796 },
  '경기 포천시': { lat: 37.8947, lng: 127.2003 },
  '경기 의왕시': { lat: 37.3449, lng: 126.9683 },
  '경기 하남시': { lat: 37.539, lng: 127.214 },
  '경기 여주시': { lat: 37.298, lng: 127.6371 },
  '경기 양평군': { lat: 37.4918, lng: 127.4876 },
  '경기 가평군': { lat: 37.831, lng: 127.51 },
  '경기 연천군': { lat: 38.0962, lng: 127.0761 },

  // ── 인천 ──
  '인천 중구': { lat: 37.4736, lng: 126.6216 },
  '인천 동구': { lat: 37.474, lng: 126.642 },
  '인천 미추홀구': { lat: 37.4636, lng: 126.6503 },
  '인천 연수구': { lat: 37.4097, lng: 126.6783 },
  '인천 남동구': { lat: 37.4471, lng: 126.7315 },
  '인천 부평구': { lat: 37.507, lng: 126.721 },
  '인천 계양구': { lat: 37.5376, lng: 126.737 },
  '인천 서구': { lat: 37.5451, lng: 126.676 },
  '인천 강화군': { lat: 37.7465, lng: 126.486 },
  '인천 옹진군': { lat: 37.4397, lng: 126.193 },

  // ── 부산 ──
  '부산 중구': { lat: 35.106, lng: 129.0324 },
  '부산 서구': { lat: 35.0978, lng: 129.0244 },
  '부산 동구': { lat: 35.1297, lng: 129.0455 },
  '부산 영도구': { lat: 35.0912, lng: 129.0679 },
  '부산 부산진구': { lat: 35.1629, lng: 129.0532 },
  '부산 동래구': { lat: 35.2046, lng: 129.0836 },
  '부산 남구': { lat: 35.1365, lng: 129.0846 },
  '부산 북구': { lat: 35.1973, lng: 128.9909 },
  '부산 해운대구': { lat: 35.1631, lng: 129.1636 },
  '부산 사하구': { lat: 35.1045, lng: 128.9751 },
  '부산 금정구': { lat: 35.2428, lng: 129.0927 },
  '부산 강서구': { lat: 35.2127, lng: 128.98 },
  '부산 연제구': { lat: 35.1762, lng: 129.0797 },
  '부산 수영구': { lat: 35.1457, lng: 129.1133 },
  '부산 사상구': { lat: 35.1524, lng: 128.9915 },
  '부산 기장군': { lat: 35.2444, lng: 129.2221 },

  // ── 대구 ──
  '대구 중구': { lat: 35.8694, lng: 128.6062 },
  '대구 동구': { lat: 35.8861, lng: 128.6353 },
  '대구 서구': { lat: 35.8721, lng: 128.5591 },
  '대구 남구': { lat: 35.846, lng: 128.5975 },
  '대구 북구': { lat: 35.8854, lng: 128.5827 },
  '대구 수성구': { lat: 35.858, lng: 128.6307 },
  '대구 달서구': { lat: 35.8299, lng: 128.5327 },
  '대구 달성군': { lat: 35.7747, lng: 128.4318 },

  // ── 광주 ──
  '광주 동구': { lat: 35.146, lng: 126.923 },
  '광주 서구': { lat: 35.1527, lng: 126.89 },
  '광주 남구': { lat: 35.133, lng: 126.9026 },
  '광주 북구': { lat: 35.1741, lng: 126.9116 },
  '광주 광산구': { lat: 35.1397, lng: 126.7937 },

  // ── 대전 ──
  '대전 동구': { lat: 36.3272, lng: 127.4548 },
  '대전 중구': { lat: 36.3256, lng: 127.4212 },
  '대전 서구': { lat: 36.3555, lng: 127.3838 },
  '대전 유성구': { lat: 36.3623, lng: 127.3563 },
  '대전 대덕구': { lat: 36.3467, lng: 127.4154 },

  // ── 울산 ──
  '울산 중구': { lat: 35.5694, lng: 129.3326 },
  '울산 남구': { lat: 35.5438, lng: 129.3295 },
  '울산 동구': { lat: 35.5048, lng: 129.4166 },
  '울산 북구': { lat: 35.5829, lng: 129.3613 },
  '울산 울주군': { lat: 35.5395, lng: 129.147 },

  // ── 세종 ──
  세종시: { lat: 36.48, lng: 127.289 },

  // ── 강원 ──
  '강원 춘천시': { lat: 37.8813, lng: 127.7299 },
  '강원 원주시': { lat: 37.3422, lng: 127.9202 },
  '강원 강릉시': { lat: 37.7519, lng: 128.8761 },
  '강원 동해시': { lat: 37.5245, lng: 129.1142 },
  '강원 태백시': { lat: 37.1641, lng: 128.9856 },
  '강원 속초시': { lat: 38.207, lng: 128.5918 },
  '강원 삼척시': { lat: 37.4507, lng: 129.165 },
  '강원 홍천군': { lat: 37.6972, lng: 127.8885 },
  '강원 횡성군': { lat: 37.4918, lng: 127.985 },
  '강원 영월군': { lat: 37.1837, lng: 128.4617 },
  '강원 평창군': { lat: 37.3683, lng: 128.3905 },
  '강원 정선군': { lat: 37.3808, lng: 128.6606 },
  '강원 철원군': { lat: 38.1467, lng: 127.3137 },
  '강원 화천군': { lat: 38.1064, lng: 127.7083 },
  '강원 양구군': { lat: 38.1099, lng: 127.9895 },
  '강원 인제군': { lat: 38.0697, lng: 128.1701 },
  '강원 고성군': { lat: 38.3802, lng: 128.4678 },
  '강원 양양군': { lat: 38.0757, lng: 128.6196 },

  // ── 충북 ──
  '충북 청주시': { lat: 36.6424, lng: 127.489 },
  '충북 충주시': { lat: 36.991, lng: 127.926 },
  '충북 제천시': { lat: 37.1326, lng: 128.191 },
  '충북 보은군': { lat: 36.4896, lng: 127.7296 },
  '충북 옥천군': { lat: 36.3064, lng: 127.5712 },
  '충북 영동군': { lat: 36.175, lng: 127.7834 },
  '충북 증평군': { lat: 36.7853, lng: 127.5815 },
  '충북 진천군': { lat: 36.8554, lng: 127.4355 },
  '충북 괴산군': { lat: 36.8154, lng: 127.7865 },
  '충북 음성군': { lat: 36.94, lng: 127.6905 },
  '충북 단양군': { lat: 36.9846, lng: 128.3657 },

  // ── 충남 ──
  '충남 천안시': { lat: 36.8151, lng: 127.1139 },
  '충남 공주시': { lat: 36.4466, lng: 127.119 },
  '충남 보령시': { lat: 36.3334, lng: 126.6129 },
  '충남 아산시': { lat: 36.7899, lng: 127.0018 },
  '충남 서산시': { lat: 36.7845, lng: 126.4504 },
  '충남 논산시': { lat: 36.1871, lng: 127.0987 },
  '충남 계룡시': { lat: 36.2745, lng: 127.2487 },
  '충남 당진시': { lat: 36.894, lng: 126.6299 },
  '충남 금산군': { lat: 36.1088, lng: 127.4882 },
  '충남 부여군': { lat: 36.2757, lng: 126.9098 },
  '충남 서천군': { lat: 36.0803, lng: 126.6918 },
  '충남 청양군': { lat: 36.459, lng: 126.8021 },
  '충남 홍성군': { lat: 36.601, lng: 126.66 },
  '충남 예산군': { lat: 36.6828, lng: 126.8489 },
  '충남 태안군': { lat: 36.7456, lng: 126.2978 },

  // ── 전북 ──
  '전북 전주시': { lat: 35.8242, lng: 127.148 },
  '전북 군산시': { lat: 35.9677, lng: 126.7367 },
  '전북 익산시': { lat: 35.9483, lng: 126.9577 },
  '전북 정읍시': { lat: 35.5699, lng: 126.8558 },
  '전북 남원시': { lat: 35.4164, lng: 127.3904 },
  '전북 김제시': { lat: 35.8036, lng: 126.8806 },
  '전북 완주군': { lat: 35.91, lng: 127.151 },
  '전북 진안군': { lat: 35.7917, lng: 127.425 },
  '전북 무주군': { lat: 36.0069, lng: 127.6604 },
  '전북 장수군': { lat: 35.6471, lng: 127.5214 },
  '전북 임실군': { lat: 35.6131, lng: 127.2794 },
  '전북 순창군': { lat: 35.3745, lng: 127.1376 },
  '전북 고창군': { lat: 35.4358, lng: 126.7021 },
  '전북 부안군': { lat: 35.7317, lng: 126.7333 },

  // ── 전남 ──
  '전남 목포시': { lat: 34.8118, lng: 126.3922 },
  '전남 여수시': { lat: 34.7604, lng: 127.6622 },
  '전남 순천시': { lat: 34.9506, lng: 127.4873 },
  '전남 나주시': { lat: 35.0158, lng: 126.7109 },
  '전남 광양시': { lat: 34.9404, lng: 127.6959 },
  '전남 담양군': { lat: 35.3212, lng: 126.9882 },
  '전남 곡성군': { lat: 35.282, lng: 127.2919 },
  '전남 구례군': { lat: 35.2026, lng: 127.4628 },
  '전남 고흥군': { lat: 34.6111, lng: 127.285 },
  '전남 보성군': { lat: 34.7715, lng: 127.0799 },
  '전남 화순군': { lat: 35.0645, lng: 126.9867 },
  '전남 장흥군': { lat: 34.6816, lng: 126.9065 },
  '전남 강진군': { lat: 34.6421, lng: 126.7672 },
  '전남 해남군': { lat: 34.5735, lng: 126.5988 },
  '전남 영암군': { lat: 34.8004, lng: 126.6965 },
  '전남 무안군': { lat: 34.9906, lng: 126.4813 },
  '전남 함평군': { lat: 35.0651, lng: 126.5165 },
  '전남 영광군': { lat: 35.277, lng: 126.512 },
  '전남 장성군': { lat: 35.3018, lng: 126.7846 },
  '전남 완도군': { lat: 34.311, lng: 126.755 },
  '전남 진도군': { lat: 34.4866, lng: 126.2633 },
  '전남 신안군': { lat: 34.7889, lng: 126.3809 },

  // ── 경북 ──
  '경북 포항시': { lat: 36.019, lng: 129.3435 },
  '경북 경주시': { lat: 35.8562, lng: 129.2247 },
  '경북 김천시': { lat: 36.1399, lng: 128.1136 },
  '경북 안동시': { lat: 36.5683, lng: 128.729 },
  '경북 구미시': { lat: 36.1196, lng: 128.3447 },
  '경북 영주시': { lat: 36.8056, lng: 128.6241 },
  '경북 영천시': { lat: 35.9732, lng: 128.9386 },
  '경북 상주시': { lat: 36.4109, lng: 128.159 },
  '경북 문경시': { lat: 36.586, lng: 128.1868 },
  '경북 경산시': { lat: 35.8252, lng: 128.741 },
  '경북 의성군': { lat: 36.3527, lng: 128.6973 },
  '경북 청송군': { lat: 36.4356, lng: 129.0571 },
  '경북 영양군': { lat: 36.6665, lng: 129.1124 },
  '경북 영덕군': { lat: 36.4147, lng: 129.3651 },
  '경북 청도군': { lat: 35.6474, lng: 128.7342 },
  '경북 고령군': { lat: 35.7264, lng: 128.2628 },
  '경북 성주군': { lat: 35.9193, lng: 128.2831 },
  '경북 칠곡군': { lat: 35.9953, lng: 128.4014 },
  '경북 예천군': { lat: 36.6553, lng: 128.453 },
  '경북 봉화군': { lat: 36.891, lng: 128.7324 },
  '경북 울진군': { lat: 36.9928, lng: 129.4003 },
  '경북 울릉군': { lat: 37.4844, lng: 130.9057 },

  // ── 경남 ──
  '경남 창원시': { lat: 35.2279, lng: 128.6816 },
  '경남 진주시': { lat: 35.18, lng: 128.1076 },
  '경남 통영시': { lat: 34.8544, lng: 128.4331 },
  '경남 사천시': { lat: 35.0034, lng: 128.0641 },
  '경남 김해시': { lat: 35.2285, lng: 128.8894 },
  '경남 밀양시': { lat: 35.5039, lng: 128.7466 },
  '경남 거제시': { lat: 34.8806, lng: 128.6211 },
  '경남 양산시': { lat: 35.335, lng: 129.0374 },
  '경남 의령군': { lat: 35.3222, lng: 128.2611 },
  '경남 함안군': { lat: 35.2722, lng: 128.4066 },
  '경남 창녕군': { lat: 35.5415, lng: 128.492 },
  '경남 고성군': { lat: 34.9732, lng: 128.322 },
  '경남 남해군': { lat: 34.8376, lng: 127.892 },
  '경남 하동군': { lat: 35.0672, lng: 127.7514 },
  '경남 산청군': { lat: 35.4155, lng: 127.873 },
  '경남 함양군': { lat: 35.5205, lng: 127.7273 },
  '경남 거창군': { lat: 35.6862, lng: 127.911 },
  '경남 합천군': { lat: 35.5666, lng: 128.166 },

  // ── 제주 ──
  '제주 제주시': { lat: 33.4996, lng: 126.5312 },
  '제주 서귀포시': { lat: 33.254, lng: 126.56 },
};